import * as React from 'react';

import { cn } from '../utils/utils';

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // `bg-background` is CORRECT here, and is deliberately the same class
          // that was just REMOVED from Button's `outline` variant. The token is
          // not "the page colour": globals.css orders the surfaces
          // card > ground > background and states that `--background` sits below
          // the page ground on purpose, "used on inputs and filter chips, which
          // should read as recessed". So on a surface it paints a sunken well
          // (the Button bug); on an input the well IS the design. This also
          // aligns the primitive with the 13 hand-rolled inputs across
          // mindspace/learning that already use it.
          //
          // `focus-visible:ring-1 focus-visible:ring-ring` matches Button's base.
          // Without it this control killed the native outline and supplied no
          // replacement — a WCAG 2.4.7 gap that every call site had to patch.
          //
          // `h-11 md:h-9`, with `text-base md:text-sm`: below `md` a field is
          // a 44px touch target with 16px type, the size under which iOS
          // Safari zooms the page into a focused field. A call site that
          // passes `text-sm` brings that zoom back on phones.
          'border-input file:text-foreground placeholder:text-muted-foreground bg-background focus-visible:ring-ring flex h-11 w-full rounded-md border px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:ring-1 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:h-9 md:text-sm',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
